import { Tabs, TabsList, TabsTrigger } from "@capacit-com/lara-law-shared-ui";

/** What the Workspaces page shows while a search is active. */
export type WorkspaceSearchResultType = "all" | "workspaces" | "documents";

interface ResultTypeSwitchProps {
  value: WorkspaceSearchResultType;
  onChange: (value: WorkspaceSearchResultType) => void;
  /** Workspaces whose name matches; undefined while loading. */
  workspaceCount?: number;
  /** Documents whose title or text matches; undefined while loading. */
  documentCount?: number;
}

const isResultType = (value: string): value is WorkspaceSearchResultType =>
  value === "all" || value === "workspaces" || value === "documents";

const Count = ({ value }: { value?: number }) =>
  value === undefined ? null : (
    <span className="ml-1.5 text-xs font-normal text-muted-foreground">
      {value}
    </span>
  );

/**
 * Lets the reader zoom the search on what they are after (LAR-235): everything, only
 * workspaces by name, or only documents by title and text.
 */
export const ResultTypeSwitch = ({
  value,
  onChange,
  workspaceCount,
  documentCount,
}: ResultTypeSwitchProps) => {
  const total =
    workspaceCount === undefined || documentCount === undefined
      ? undefined
      : workspaceCount + documentCount;

  return (
    <Tabs
      value={value}
      onValueChange={(next) => {
        if (isResultType(next)) onChange(next);
      }}
    >
      <TabsList aria-label="Resultattype">
        <TabsTrigger value="all">
          Alle
          <Count value={total} />
        </TabsTrigger>
        <TabsTrigger value="workspaces">
          Workspaces
          <Count value={workspaceCount} />
        </TabsTrigger>
        <TabsTrigger value="documents">
          Dokumenter
          <Count value={documentCount} />
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};

export default ResultTypeSwitch;
